import { CopyIcon } from "@expert/common-ui/assets";
import { SoundNotificationsSwitch } from "@expert/proactive-notifications";
import { Button, Menu, Space, Stack, Text, Tooltip } from "@mantine/core";

import { CaretDown, CaretUp, Exit, UserInitial } from "@/common-ui";

import type { ProfileData } from "./useProfileData";

import classes from "./Profile.module.css";
import { ThemeControls } from "./ThemeControls";

interface ProfileViewProps {
    profileData: ProfileData;
}

export function ProfileView({ profileData }: ProfileViewProps) {
    const {
        agentName,
        formattedVersionNumber,
        menuOpen,
        setMenuOpen,
        isProactiveEnabled,
        isLightModeEnabled,
        disableLogOff,
        copyToDebug,
        logOff,
        handleProfileMenuView,
        onSoundNotificationsClick,
    } = profileData;
    return (
        <Menu
            shadow="sm"
            radius="md"
            id="agent-profile-menu"
            zIndex="var(--mantine-priority-highest)"
            opened={menuOpen}
            onChange={setMenuOpen}
            closeOnClickOutside
            closeOnItemClick={false}
        >
            <Menu.Target>
                <Button
                    color="var(--mantine-color-text)"
                    data-testid="agent-profile-menu"
                    id="agent-profile-menu"
                    leftSection={<UserInitial name={agentName} />}
                    data-menu-open={menuOpen}
                    className={classes.profileBtn}
                    onClick={handleProfileMenuView}
                    size="xs"
                    variant="subtle"
                    maw={200}
                >
                    <Tooltip
                        label={agentName}
                        zIndex="var(--mantine-priority-highest)"
                        openDelay={1_000}
                        closeDelay={250}
                        opened={menuOpen ? false : undefined}
                    >
                        <Text data-expert-name={agentName} size="xs" truncate>
                            {agentName}
                        </Text>
                    </Tooltip>
                    <Space w="xs" />
                    {menuOpen ? <CaretUp /> : <CaretDown />}
                </Button>
            </Menu.Target>
            <Menu.Dropdown>
                {isProactiveEnabled && <SoundNotificationsSwitch onClick={onSoundNotificationsClick} />}
                <Menu.Item
                    id="copy-troubleshooting-menu-item"
                    leftSection={<CopyIcon width={20} height={21} stroke="var(--mantine-color-dark-3)" />}
                    key="Copy Troubleshooting"
                    onClick={copyToDebug}
                >
                    <Text size="xs">Copy troubleshoot info</Text>
                </Menu.Item>
                <Menu.Item
                    leftSection={<Exit height={20} width={20} fill="var(--mantine-color-red-5)" />}
                    id="log-off-menu-item"
                    key="Log Off"
                    color="red.5"
                    onClick={logOff}
                    disabled={disableLogOff}
                >
                    <Text size="xs">End your shift</Text>
                </Menu.Item>

                {isLightModeEnabled && (
                    <>
                        <Menu.Divider />
                        <Stack id="settings-section" p="sm" w="100%" justify="center" align="center">
                            <ThemeControls />
                        </Stack>
                    </>
                )}

                <Menu.Divider />

                <Text size="xs" mb="sm" className={classes.versionText}>
                    {formattedVersionNumber}
                </Text>
            </Menu.Dropdown>
        </Menu>
    );
}
